module.exports = __webpack_public_path__ + "static/media/rail-h.dc334710.jpg";